import { Box, Container, Flex, Text, Image, Heading, Grid, GridItem, Spacer, Stack, Avatar, useColorModeValue, SimpleGrid } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { FiUsers } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import ProgramService from "services/programs/program-service";
import Layout from "scenes/layouts";
import AppConsts from "../../libs/appconst";

const ProgramScene = (): ReactElement => {
    const navigate = useNavigate();
    const [programs, setPrograms] = useState<any>([]);
    const [isLoading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        ProgramService.GetProgramDiscover().then((response: any) => {
            setPrograms(response.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    if (isLoading)
        return <LoadingScreen />;
    else
        return (
            <Layout>
                <Container maxWidth={"8xl"} mt={6} mb={5}>
                    <Text fontSize={'3xl'} fontWeight={"extrabold"}>Programs</Text>
                    <SimpleGrid columns={[1, 2, 4]} gap={6} mt={4}>
                        {
                            programs.map((program: any) => {
                                return (
                                    <Box flex={3} rounded={'lg'} boxShadow={'lg'} border={'1px'} borderColor={"gray.400"} cursor={'pointer'}
                                        onClick={() => navigate(`/checkout/${program.id}?utm_source=direct&utm_medium=webapp&utm_campaign=program`)}
                                    >
                                        <Box
                                            w={'full'}
                                            //bg={useColorModeValue('white', 'gray.900')}
                                            bg={'white'}
                                            boxShadow={'md'}
                                            rounded={'md'}
                                            overflow={'hidden'}>
                                            <Box
                                                pos={'relative'}>
                                                <Image
                                                    src={program.posterUrl}
                                                />
                                            </Box>
                                            <Flex px={5} py={3}>
                                                <Box>
                                                    <Heading fontSize={'sm'}>
                                                        {program.name}
                                                    </Heading>
                                                    <Text fontSize={'xs'} fontWeight={'bold'} mt={0}>
                                                        {program.author.name}
                                                    </Text>

                                                    <Text fontSize={'xs'} mt={1} noOfLines={[2, 3, 4]}>
                                                        {program.description}
                                                    </Text>
                                                </Box>
                                                <Spacer />

                                                <Box >
                                                    <Flex alignItems={'center'} fontSize={'sm'}>
                                                        <FiUsers />
                                                        <Text ml={2}>
                                                            {program.enrolled}
                                                        </Text>
                                                    </Flex>
                                                </Box>
                                            </Flex>
                                        </Box>
                                    </Box>
                                )
                            })
                        }

                    </SimpleGrid>
                </Container>
            </Layout>
        );
};

export default ProgramScene;